/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online Timer — Free Countdown Timer with Alarm | Toolverse`)
};

const es_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Online — Cuenta Regresiva Gratis con Alarma | Toolverse`)
};

const de_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online-Timer — Kostenloser Countdown-Timer mit Alarm | Toolverse`)
};

const nl_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online Timer — Gratis Afteltimer met Alarm | Toolverse`)
};

const fr_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuteur en ligne — Compte à rebours gratuit avec alarme | Toolverse`)
};

const it_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer Online — Countdown Gratuito con Allarme | Toolverse`)
};

const pt_br2_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Online — Contagem Regressiva Grátis com Alarme | Toolverse`)
};

const pt_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Online — Contagem Decrescente Gratuita com Alarme | Toolverse`)
};

const ja_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインタイマー — 無料のアラーム付きカウントダウンタイマー | Toolverse`)
};

const zh_timer_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线计时器 — 免费倒计时闹铃工具 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_meta_title", locale)
	if (locale === "en") return en_timer_hub_meta_title(inputs)
	if (locale === "es") return es_timer_hub_meta_title(inputs)
	if (locale === "de") return de_timer_hub_meta_title(inputs)
	if (locale === "nl") return nl_timer_hub_meta_title(inputs)
	if (locale === "fr") return fr_timer_hub_meta_title(inputs)
	if (locale === "it") return it_timer_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_meta_title(inputs)
	if (locale === "pt") return pt_timer_hub_meta_title(inputs)
	if (locale === "ja") return ja_timer_hub_meta_title(inputs)
	return zh_timer_hub_meta_title(inputs)
};